import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { posGetInventoryAction } from '../../helpers/pos-api';
import {
    POS_GET_INVENTORY,
    getPosInventorySuccess,
    getPosInventoryError
} from './actions';

function* getInventorySaga({ payload, token }) {
    try {
        const response = yield call(posGetInventoryAction, payload, token);
        if (response.status === 'success') {
            // Filter เฉพาะสินค้าที่เป็น POS (pos_status = 1)
            const posItems = response.data.filter(item => item.pos_status === 1 || item.pos_status === true);
            yield put(getPosInventorySuccess(posItems));
        } else {
            yield put(getPosInventoryError(response.msg));
        }
    } catch (error) {
        yield put(getPosInventoryError(error));
    }
}

export function* watchGetInventory() {
    yield takeEvery(POS_GET_INVENTORY, getInventorySaga);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetInventory),
    ]);
}